import React from 'react';
import { BRAND_COLORS } from '../../config/brand';

export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26.093}
    height={18.638}
    className={className}
  >
    <g data-name="Icon ionic-ios-card" fill={BRAND_COLORS.primary}>
      <path
        data-name="Path 12163"
        d="M26.093 1.864A1.869 1.869 0 0 0 24.229 0H1.864A1.869 1.869 0 0 0 0 1.864v2.8h26.093Z"
      />
      <path
        data-name="Path 12164"
        d="M0 16.774a1.869 1.869 0 0 0 1.864 1.864h22.365a1.869 1.869 0 0 0 1.864-1.864V7.455H0Zm8.27-2.8h9.552a.818.818 0 0 1 .815.815.818.818 0 0 1-.815.815H8.27a.818.818 0 0 1-.815-.815.818.818 0 0 1 .815-.811Zm-4.193 0h.7a.818.818 0 0 1 .815.815.818.818 0 0 1-.815.815h-.7a.818.818 0 0 1-.815-.815.818.818 0 0 1 .815-.811Z"
      />
    </g>
  </svg>
);
